var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const customCache = new Set();
export function useIconfont(scriptUrl) {
  return __async(this, null, function* () {
    if (typeof document !== "undefined" && typeof window !== "undefined" && typeof document.createElement === "function" && typeof scriptUrl === "string" && scriptUrl.length && !customCache.has(scriptUrl)) {
      const script = document.createElement("script");
      script.setAttribute("src", scriptUrl);
      script.setAttribute("data-namespace", scriptUrl);
      customCache.add(scriptUrl);
      document.body.appendChild(script);
      yield new Promise((resolve, reject) => {
        script.onload = resolve;
        script.onerror = reject;
      });
    }
  });
}
